import React, { useEffect } from "react";
import {
  Container,
  Typography,
  Grid,
  Box,
  useMediaQuery,
  IconButton,
  Chip,
  useTheme,
} from "@mui/material";
import { StyledButton, GradientBackground } from "./StyledComponents";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import Header from "./Header";
import Footer from "./Footer";
import TestimonialsSection from "./TestimonialsSection";
import { motion } from "framer-motion";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import UniversitySection from "./UniversitySection";
import MediaSection from "./MediaSection";
import PricesSection from "./PricesSection";
import ContactForm from "./ContactForm";

const PricesPage = ({ toggleDarkMode, isDark, styles, theme }) => {
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Priser | Studera.ai</title>
        <meta
          name="description"
          content="Lär dig mer kostnaderna för lärare, pedagoger och elever för att använda Studera.ai."
        />
        <meta name="robots" content="noindex" />
      </Helmet>

      <Header />

      <GradientBackground className="gradient-background">
        <Container
          sx={{
            pt: { xs: 10, md: 20 },
            pb: { xs: 6, md: 14 },
            position: "relative",
            textAlign: "center",
            width: { xs: "100%", md: "70%" },
          }}
        >
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} md={12} sx={{ textAlign: "center" }}>
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
              >
                <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                  <Chip
                    label={
                      <span>
                        Studera.ai{" "}
                        <span style={{ opacity: 0.7 }}>
                          &nbsp;•&nbsp; Framtidens lärande
                        </span>
                      </span>
                    }
                    sx={{
                      backgroundColor: "rgba(255, 255, 255, 0.1)",
                      color: "white",
                      fontWeight: "600",
                      fontSize: "0.8rem",
                      padding: "2px 14px",
                      mb: 4,
                      borderRadius: "16px",
                      "& .MuiChip-label": {
                        padding: "0 4px",
                      },
                    }}
                  />
                </Box>

                <Typography
                  variant="h2"
                  component="h1"
                  gutterBottom
                  sx={{
                    fontWeight: 700,
                    width: { xs: "100%", md: "90%" },
                    fontSize: { xs: "2.5rem", md: "3.5rem" },
                    margin: "0 auto",
                  }}
                >
                  Priser för Studera.AI
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    fontSize: { xs: "1rem", md: "1.2rem" },
                    lineHeight: { xs: "1.6rem", md: "2.2rem" },
                    fontWeight: { xs: "400", md: "400" },
                    color: "#e5e5e5",

                    width: { xs: "100%", md: "90%" },
                    margin: "0 auto",
                    mt: 3,
                    mb: 3,
                  }}
                >
                  Det är helt gratis att använda tjänsten men det finns en
                  daglig begränsning på hur mycket man får generera. Uppgradera
                  för full åtkomst.
                </Typography>
              </motion.div>
            </Grid>
          </Grid>
        </Container>
      </GradientBackground>
      <Container sx={{ my: { xs: 8, md: 13 } }}>
        <Typography
          variant="h3"
          align="center"
          sx={{
            fontWeight: "bold",
            fontSize: "2.3em",
            mb: 3,
          }}
        >
          Hitta rätt prisplan
        </Typography>

        <Typography
          variant="h6"
          paragraph
          color="text.secondary"
          sx={{ textAlign: "center", display: "block", mb: 4 }}
        >
          Utforska kostnader för privatpersoner och skolor
        </Typography>

        <PricesSection styles={styles} theme={theme} pricesPage={true} />
      </Container>

      <ContactForm showMoreFields={true} bgcolor="background.paper" />

      {/*
      <TestimonialsSection source="teacher" />
      */}
      <UniversitySection bgcolor="background.paper" showHeadline={true} />
      <MediaSection bgcolor="background.default" />
      <Footer />

      {!isMobile && (
        <Box sx={{ position: "fixed", bottom: 16, right: 16, zIndex: 9999 }}>
          <IconButton onClick={toggleDarkMode}>
            {isDark ? <LightModeIcon /> : <DarkModeIcon />}
          </IconButton>
        </Box>
      )}
    </>
  );
};

export default PricesPage;
